import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { CanvasOverlay } from "./canvas-overlay";
import * as Styled from "./cup-technology-indicator.style";
import { getFlowRestrictionColor } from "ui/components/panels/dashboard/boxes/flow-restriction-findings.style";
import { FlowRestrictionIcon, } from "ui/components/elements/icons/flow-restriction";
import { getFlowRestrictionState, isFlowRestrictionFunctioningAsIntended, } from "utility/flow-restrictions";
var getIconState = function (cupTechnology, performance) {
    if (performance)
        return getFlowRestrictionState(performance);
    if (cupTechnology.type === "Restrict")
        return "restrictor";
    if (cupTechnology.type === "Sense")
        return "unknown";
    return undefined;
};
export var CupTechnologyIndicator = function (_a) {
    var anchorX = _a.anchorX, anchorY = _a.anchorY, cupTechnology = _a.cupTechnology, performance = _a.performance, highlight = _a.highlight;
    var t = useTranslation().t;
    var theme = useTheme();
    var iconState = getIconState(cupTechnology, performance);
    var iconColor = performance
        ? getFlowRestrictionColor(theme, isFlowRestrictionFunctioningAsIntended(performance))
        : theme.colors.palette.grey[500];
    var name = cupTechnology.code
        ? "".concat(cupTechnology.code, " - ").concat(cupTechnology.label)
        : cupTechnology.label;
    var title = iconState === "open" || iconState === "closed"
        ? "".concat(name, " (").concat(t("flow_restrictions.state_".concat(iconState)), ")")
        : name;
    return (_jsx(CanvasOverlay, { x: anchorX, y: anchorY, children: _jsxs(Styled.CupTechnologyIndicator, { title: title, highlight: highlight, "data-highlight": highlight, children: [iconState && (_jsx(FlowRestrictionIcon, { state: iconState, color: iconColor, size: 16 })), _jsx(Styled.Label, { children: cupTechnology.code })] }) }));
};
